import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Komfort = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <g fill="none" fillRule="evenodd">
      <circle fill="#FFA86A" cx="24" cy="24" r="24" />
      <path
        d="M23.99 14C18.47 14 14 18.48 14 24s4.47 10 9.99 10C29.52 34 34 29.52 34 24s-4.48-10-10.01-10zM24 32c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H18.89c.8 2.04 2.78 3.5 5.11 3.5z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>{' '}
  </SvgIcon>
);

export default Komfort;
